import { useMemo } from "react";
import { Navigate } from "react-router-dom";
import VisualizeContext from "../../Contexts/Visualize/VisualizeContext";
import MainContent from "./MainContent/MainContent";
import SideMenu from "./SideMenu/SideMenu";
import Wrapper from "./Visualize.style";
import { CHART_MENU_TYPES, filterChartCategoriesForMenu, useChartCategories } from "../../Hooks/useChartCategories";
import { Loader } from "../Shared/Loader/Loader";

const Visualize = ({ menuType = CHART_MENU_TYPES.INTERACTIVE, chartBaseRoute }) => {
    const { chartCategories, loading } = useChartCategories();
    const visibleChartCategories = useMemo(
        () => filterChartCategoriesForMenu(chartCategories, menuType),
        [chartCategories, menuType]
    );
    const singleVisibleChart = useMemo(() => {
        if (visibleChartCategories.length !== 1) {
            return null;
        }

        const [category] = visibleChartCategories;
        if (!Array.isArray(category?.charts) || category.charts.length !== 1) {
            return null;
        }

        return {
            categoryDisplayName: category.displayName,
            chart: category.charts[0],
        };
    }, [visibleChartCategories]);

    if (loading) {
        return (
            <Wrapper>
                <Loader title="Loading visualizations" height="70vh" />
            </Wrapper>
        );
    }

    if (menuType === CHART_MENU_TYPES.MARKET_SNAPSHOT && singleVisibleChart) {
        const routeId = singleVisibleChart.chart.routeId ?? singleVisibleChart.chart.title.split(' ').join('-');
        return (
            <Navigate
                replace
                to={`${chartBaseRoute}/${routeId}?path=${encodeURIComponent(singleVisibleChart.categoryDisplayName)}`}
            />
        );
    }

    return (
        <VisualizeContext.Provider value={{ ChartCategories: visibleChartCategories }}>
            <Wrapper>
                <SideMenu chartCategories={visibleChartCategories} chartBaseRoute={chartBaseRoute} />
                <div style={{ flex: 1 }}>
                    <MainContent chartCategories={visibleChartCategories} />
                </div>
            </Wrapper>
        </VisualizeContext.Provider>
    );
}

export default Visualize;